export enum StatusAverbacao {
  PENDENTE = 'PENDENTE',
  APROVADA = 'APROVADA',
  REJEITADA = 'REJEITADA',
}

export enum StatusPrestacaoTarefa {
  ATIVO = 'ATIVO',
  ENCERRADO = 'ENCERRADO',
}

export enum ModalidadePrestacaoTarefa {
  PPTC = 'PPTC',
  DSA = 'DSA',
}

export enum TipoDesconto {
  LTIP = 'LTIP',
  LTSPF = 'LTSPF',
  PENA_PRIVATIVA = 'PENA_PRIVATIVA',
  PRISAO = 'PRISAO',
  DESERCAO = 'DESERCAO',
  SUSPENSAO_POSTO = 'SUSPENSAO_POSTO',
  CONDICAO_RESTRITIVA = 'CONDICAO_RESTRITIVA',
}

export enum EfeitoAgregacao {
  NEUTRO = 'NEUTRO',
  DESCONTA = 'DESCONTA',
  AVALIAR = 'AVALIAR',
}

export interface TempoDecomposto {
  anos: number;
  meses: number;
  dias: number;
}

export interface DescontoTempoDTO {
  id: string;
  tipo: TipoDesconto;
  dataInicio: string;
  dataFim: string;
  duracao: TempoDecomposto;
  justificativa: string;
  baseLegal: string;
  dominioOrigem: string;
}

export interface TipoTempoServicoPMDFDTO {
  id: number;
  codigoPmdf: number;
  descricao: string;
  ativo: boolean;
}

export interface TipoTempoServicoTCDFDTO {
  id: number;
  idTcdf: number;
  tipoPmdf: TipoTempoServicoPMDFDTO;
  naturezaTempoAverbado: string;
  regimeJuridico: string;
  esfera: string;
  ponderado: boolean;
  isDefault: boolean;
  ativo: boolean;
}

export interface AverbacaoDTO {
  id: string;
  tipoTempoTcdf: TipoTempoServicoTCDFDTO;
  dataInicio: string;
  dataFim: string;
  duracao: TempoDecomposto;
  processoSei: string;
  numeroDocumento?: string;
  nomeEmpresa?: string;
  cnpjEmpresa?: string;
  observacao?: string;
  certidaoUrl?: string;
  nomeAnexo?: string;
  status: StatusAverbacao;
  aprovadoPor?: string;
  aprovadoEm?: string;
  criadoPor: string;
  criadoEm: string;
}

export interface AverbacaoCreateRequest {
  naturezaServicoAverbadoId: number;
  dataInicio: string;
  dataFim: string;
  processoSei: string;
  numeroDocumento?: string;
  nomeEmpresa?: string;
  cnpjEmpresa?: string;
  observacao?: string;
}

export interface PeriodoReservaIndevidaDTO {
  id: string;
  dataInicioReserva: string;
  dataRetornoAtiva: string;
  totalPausa: TempoDecomposto;
  processoSei: string;
  motivo: string;
}

export interface PeriodoPrestacaoTarefaDTO {
  id: string;
  modalidade: ModalidadePrestacaoTarefa;
  dataInicio: string;
  dataFim: string;
  totalTempo: TempoDecomposto;
  status: StatusPrestacaoTarefa;
}

export interface FichaTempoServicoDTO {
  matricula: string;
  nomeCompleto: string;
  postoGraduacao: string;
  quadro: string;
  dataAdmissao: string;
  dataNascimento: string;
  tempoEfetivoServico: TempoDecomposto;
  totalAnosServico: TempoDecomposto;
  tempoEm31122019: TempoDecomposto;
  pedagio17Porcento: TempoDecomposto;
  dataProjetadaReserva: string;
  dataReservaComPedagio: string;
  indicadorDireitoAdquirido: boolean;
  descontos: DescontoTempoDTO[];
  averbacoes: AverbacaoDTO[];
  periodosReservaIndevida: PeriodoReservaIndevidaDTO[];
  periodosPptcDsa: PeriodoPrestacaoTarefaDTO[];
}

export interface CenarioSimulacao {
  nome: string;
  averbacoesFicticias: {
    dataInicio: string;
    dataFim: string;
    regime: 'RGPS' | 'RPPS' | 'MILITAR';
  }[];
  descontosRemovidos: string[];
  descontosAdicionados: {
    tipo: TipoDesconto;
    dataInicio: string;
    dataFim: string;
  }[];
  dataApuracao?: string;
  leEmDobroAtivada: boolean;
  parametrosAlterados?: { chave: string; valor: string }[];
}

export interface SimulacaoRequest {
  cenarios: CenarioSimulacao[];
}

export interface SimulacaoResponse {
  cenarioReal: FichaTempoServicoDTO;
  cenariosSimulados: {
    nome: string;
    ficha: FichaTempoServicoDTO;
    deltaDias: number;
  }[];
}

export interface RascunhoSimulacaoDTO {
  id: string;
  nome: string;
  cenariosJson: SimulacaoRequest;
  criadoPor: string;
  criadoEm: string;
  expiraEm: string;
}

export interface SalvarRascunhoRequest {
  nome: string;
  cenarios: SimulacaoRequest;
}

export interface DistribuicaoItem {
  label: string;
  valor: number;
}

export interface DashboardPosicaoAtualDTO {
  totalPmsAtivos: number;
  pmsDireitoAdquirido: number;
  pmsMenos1Ano: number;
  pms1a3Anos: number;
  pms3a5Anos: number;
  tempoMedioServico: TempoDecomposto;
  averbacoesPendentes: number;
  distribuicaoTempoRestante: DistribuicaoItem[];
  distribuicaoIdade: DistribuicaoItem[];
  distribuicaoPostoGraduacao: DistribuicaoItem[];
  distribuicaoQuadro: DistribuicaoItem[];
}

export interface ProjecaoItem {
  periodo: string;
  quantidade: number;
  acumulado: number;
}

export interface ImpactoOpmItem {
  opmId: string;
  opmNome: string;
  quantidade1Ano: number;
  quantidade3Anos: number;
  quantidade5Anos: number;
}

export interface DashboardProjecoesDTO {
  projecao12Meses: ProjecaoItem[];
  projecao5Anos: ProjecaoItem[];
  projecao10Anos: ProjecaoItem[];
  impactoPorOpm: ImpactoOpmItem[];
  impactoPorPosto: DistribuicaoItem[];
  curvaEnvelhecimento: ProjecaoItem[];
  projecaoDeficitEfetivo: ProjecaoItem[];
}

export interface LoteContratacao {
  anoAdmissao: number;
  quantidade: number;
  postoGraduacaoInicial: string;
  quadro: string;
  distribuicaoSexoJson: {
    masculino: number;
    feminino: number;
  };
  idadeMedia: number;
}

export interface AlteracaoParametro {
  chave: string;
  novoValor: string;
}

export interface TaxaEvasao {
  quadro: string;
  postoGraduacao?: string;
  taxaAnualPercentual: number;
}

export interface ProjecaoAnualEfetivo {
  ano: number;
  efetivoAtivo: number;
  distribuicaoPosto: DistribuicaoItem[];
  distribuicaoQuadro: DistribuicaoItem[];
  distribuicaoIdade: DistribuicaoItem[];
  distribuicaoSexo: DistribuicaoItem[];
  saidasReserva: number;
  entradasConcurso: number;
}

export interface DeltaAnual {
  ano: number;
  deltaAbsoluto: number;
  deltaPercentual: number;
}

export interface PainelDecisao {
  mediaTempoPostergado: TempoDecomposto;
  cronogramaContratacaoSugerido: { ano: number; quantidade: number }[];
}

export interface MacroSimulacaoRequest {
  contratacoesSimuladas: LoteContratacao[];
  alteracoesRegrasSimuladas: AlteracaoParametro[];
  taxasEvasaoSimuladas: TaxaEvasao[];
}

export interface MacroSimulacaoResponse {
  projecaoReal: ProjecaoAnualEfetivo[];
  projecaoSimulada: ProjecaoAnualEfetivo[];
  deltas: DeltaAnual[];
  painelDecisao: PainelDecisao;
}

export interface ListaNominativaItemDTO {
  matricula: string;
  nomeCompleto: string;
  postoGraduacao: string;
  quadro: string;
  opmNome: string;
  tempoEfetivo: TempoDecomposto;
  tempoRestante: TempoDecomposto;
  dataProjetadaReserva: string;
  direitoAdquirido: boolean;
}
